import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8fd1420a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sales-report-new-header" };
const _hoisted_2 = { class: "sales-report-new-header__filters" };
import FilterContact from '../../components/Header/components/Filters/Contact/FilterContact.vue';
import FilterSales from '../../components/Header/components/Filters/Sales/FilterSales.vue';
import FilterSegments from '../../components/Header/components/Filters/Segments/FilterSegments.vue';
// libs;
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SalesReportNewHeader',
    setup(__props) {
        // components
        const store = useStore();
        const updateSegment = (selectedSegment) => store.dispatch('salesReportNew/setFetchSegmentOptions', selectedSegment);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('campaign.sales-report.header.title')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(FilterContact),
                    _createVNode(FilterSales),
                    _createVNode(FilterSegments, { onUpdateSegment: updateSegment })
                ])
            ]));
        };
    }
});
